module.exports = __webpack_public_path__ + "static/media/study220201.6a5c9db0.png";